import { useEffect, useState } from "react";
import http from "services/httpService";

function useFetchCompany() {
  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCompanyData();
  }, []);

  const fetchCompanyData = async () => {
    setLoading(true);
    try {
      const { data } = await http.get("/business/get_company_product_details/");
      localStorage.setItem("products", JSON.stringify(data.product_details));
      localStorage.setItem("products_with_permissions", JSON.stringify(data));
      setCompany(data);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };
  return {
    company,
    loading,
  };
}

export default useFetchCompany;
